import $http from '../../shared/http';
import moment from 'moment';
import { downloadFileFromResponse } from '../../shared/utils';

export const rosters = {
  namespaced: true,
  state: () => {
    return {
      rosterTemplateCreated: false,
      rosterTemplateRegisterData: null,
      currentRosterTemplate: null,
      rosterTemplateEdited: false,
      rosterTemplatesForSelect: null,
      isRosterTemplateDownloaded: false,
      rosterTemplateEditData: null,
      rosterTemplateUsed: null,
      rosterTemplateDisabled: null,
      currentMonth: moment().startOf('month'),
      currentMonthRoster: null,
      isDefaultRosterTemplateExist: null,
    };
  },
  getters: {
    getRosterTemplatesForSelect: (state) => state.rosterTemplatesForSelect,
    getRosterTemplateCreated: (state) => state.rosterTemplateCreated,
    getCurrentRosterTemplate: (state) => state.currentRosterTemplate,
    getCurrentRosterTemplateID: (state) =>
      state.currentRosterTemplate ? state.currentRosterTemplate.id : null,
    getRosterTemplateDownloaded: (state) => state.isRosterTemplateDownloaded,
    getRosterTemplateUsed: (state) => state.rosterTemplateUsed,
    getRosterTemplateDisabled: (state) => state.rosterTemplateDisabled,
    getCurrentMonth: (state) => state.currentMonth,
    getCurrentMonthRoster: (state) => state.currentMonthRoster,
    GET_DEFAULT_ROSTER_TEMPLATE_EXISTENCE: (state) => state.isDefaultRosterTemplateExist,

    rosterCollector: (state) => {
      try {
        if (state.currentMonthRoster) {
          let serviceDates = {};
          let serviceActivities = {};
          let serviceLeaders = {};
          for (const serviceType in state.currentMonthRoster) {
            if (state.currentMonthRoster.hasOwnProperty(serviceType)) {
              const services = state.currentMonthRoster[serviceType];
              serviceDates[serviceType] = [];
              serviceLeaders[serviceType] = {};
              for (const service of services) {
                if (service) {
                  // Collect service dates
                  const serviceDate = service.service_date;
                  serviceDates[serviceType].push(serviceDate);

                  // Collect service activities
                  const serviceActivitiesSchedules = service.serviceActivitiesSchedules;
                  // Use reduce to scan through the entire serviceActivitiesSchedules array and extract the activity names
                  serviceActivities[serviceType] = [];

                  serviceActivitiesSchedules.forEach((schedule) => {
                    if (schedule && schedule.serviceActivity) {
                      //console.log(serviceActivities);

                      const isLeaderVisitor = Boolean(schedule.is_visitor);
                      const activityName = schedule.serviceActivity.name;
                      const addNotes = Boolean(schedule.add_notes);

                      let leaderFullName;
                      if (!isLeaderVisitor) {
                        leaderFullName = schedule.scheduledMember?.full_name?.toUpperCase() ?? '';
                      } else {
                        leaderFullName =
                          schedule && schedule.visitor
                            ? `${schedule.visitor.first_name}${
                                schedule.visitor.middle_name
                                  ? ' ' + schedule.visitor.middle_name
                                  : ''
                              }${
                                schedule.visitor.last_name ? ' ' + schedule.visitor.last_name : ''
                              } (Visitor)`.toUpperCase()
                            : '';
                      }

                      if (!serviceLeaders[serviceType][activityName]) {
                        serviceLeaders[serviceType][activityName] = {};

                        if (!serviceLeaders[serviceType][activityName][serviceDate]) {
                          serviceLeaders[serviceType][activityName][serviceDate] = {};
                          serviceLeaders[serviceType][activityName][serviceDate].notes = addNotes
                            ? schedule.notes
                            : null;

                          serviceLeaders[serviceType][activityName][serviceDate].leaders = [];
                          serviceLeaders[serviceType][activityName][serviceDate].leaders.push(
                            leaderFullName
                          );
                        } else {
                          serviceLeaders[serviceType][activityName][serviceDate].notes = addNotes
                            ? schedule.notes
                            : null;

                          serviceLeaders[serviceType][activityName][serviceDate].leaders.push(
                            leaderFullName
                          );
                        }
                      } else if (!serviceLeaders[serviceType][activityName][serviceDate]) {
                        serviceLeaders[serviceType][activityName][serviceDate] = {};
                        serviceLeaders[serviceType][activityName][serviceDate].notes = addNotes
                          ? schedule.notes
                          : null;
                        serviceLeaders[serviceType][activityName][serviceDate].leaders = [];
                        serviceLeaders[serviceType][activityName][serviceDate].leaders.push(
                          leaderFullName
                        );
                      } else {
                        if (serviceLeaders[serviceType][activityName][serviceDate]) {
                          serviceLeaders[serviceType][activityName][serviceDate].notes = addNotes
                            ? schedule.notes
                            : null;
                          serviceLeaders[serviceType][activityName][serviceDate].leaders.push(
                            leaderFullName
                          );
                        }
                      }

                      if (
                        serviceActivities[serviceType] &&
                        Array.isArray(serviceActivities[serviceType])
                      ) {
                        serviceActivities[serviceType].push({
                          name: activityName,
                          sortOrder:
                            schedule?.serviceActivity?.ServiceActivitiesTemplates?.[0]?.pivot
                              ?.sort_order,
                        });
                      }
                    }
                  });

                  //console.log(serviceLeaders);
                }
              }
            }
          }

          // Get unique values
          //serviceActivities = new Set(serviceActivities.map(item => item));
          //console.log(serviceActivities);
          let serviceActivitiesMaps = {};
          for (const serviceType in serviceActivities) {
            if (serviceActivities.hasOwnProperty(serviceType)) {
              const activities = serviceActivities[serviceType];
              serviceActivitiesMaps[serviceType] = new Set(
                activities.sort((a, b) => a.sortOrder - b.sortOrder).map((item) => item.name)
              );
            }
          }

          return {
            serviceDates: serviceDates,
            serviceActivities: { activityNames: serviceActivitiesMaps },
            serviceLeaders,
          };
        } else return null;
      } catch (error) {
        console.log(error);
        return void 0;
      }
    },

    isCurrentMonthRosterNotComplete: (state) => {
      try {
        if (state.currentMonthRoster) {
          let checkingArray = [];
          for (const serviceType in state.currentMonthRoster) {
            if (state.currentMonthRoster.hasOwnProperty(serviceType)) {
              const services = state.currentMonthRoster[serviceType];
              const containNull = services.some((service) => !service);
              if (containNull) checkingArray.push(true);
            }
          }
          return checkingArray.some((element) => element === true);
        } else return true;
      } catch (error) {
        console.log(error);
        return void 0;
      }
    },
  },
  mutations: {
    setRosterTemplatesForSelect: (state, payload) => (state.rosterTemplatesForSelect = payload),
    initRosterTemplateForm: (state) => {
      state.rosterTemplatesForSelect = null;
    },
    setRosterTemplateCreated: (state, payload) => (state.rosterTemplateCreated = payload),
    setRosterTemplateEdited: (state, payload) => (state.rosterTemplateEdited = payload),
    setNewRosterTemplateID: (state, payload) => (state.newRosterTemplateID = payload),
    setEditRosterTemplateID: (state, payload) => (state.editRosterTemplateID = payload),
    setCurrentRosterTemplate: (state, data) => {
      state.currentRosterTemplate = data;
    },
    setRosterTemplateDownloaded: (state, payload) => {
      state.isRosterTemplateDownloaded = payload;
    },
    setDefaultRosterTemplateExistence: (state, payload) => {
      state.isDefaultRosterTemplateExist = payload;
    },
    setRosterTemplateUsed: (state, payload) => {
      state.rosterTemplateUsed = payload;
    },
    setRosterTemplateDisabled: (state, payload) => {
      state.rosterTemplateDisabled = payload;
    },
    setCurrentMonth: (state, payload) => {
      state.currentMonth = payload;
    },
    setCurrentMonthRoster: (state, payload) => {
      state.currentMonthRoster = payload;
    },
  },
  actions: {
    async CREATE_ROSTER_ACTION(ctx, { churchId, form }) {
      return $http('v2')
        .post(`/organisations/${churchId}/rosters`, form, { headers: { 'X-Is-Notifiable': 'On' } })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async UPDATE_ROSTER_ACTION(ctx, { churchId, form, rosterId }) {
      return $http('v2')
        .put(`/organisations/${churchId}/rosters/${rosterId}`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async DELETE_ROSTER_ACTION(ctx, { churchId, id }) {
      return $http('v2')
        .delete(`/organisations/${churchId}/rosters/${id}`, {
          notifiable: true,
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async loadRosterTemplatesForSelect({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get(`/organisations/${churchId}/roster_templates/select`, { canBeImpersonated: true })
          .then((response) => {
            commit('setRosterTemplatesForSelect', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async createRosterTemplateAction({ commit }, { form }) {
      commit('setRosterTemplateCreated', false);

      return $http()
        .post('/roster-templates', form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          commit('setRosterTemplateCreated', true);
          return response;
        })
        .catch((error) => {
          commit('setRosterTemplateCreated', false);
          return Promise.reject(error);
        });
    },
    async updateRosterTemplateAction({ commit }, { id, form }) {
      commit('setRosterTemplateCreated', false);

      return $http()
        .patch(`/roster-templates/${id}`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .catch((error) => {
          commit('setRosterTemplateCreated', false);
          return Promise.reject(error);
        });
    },

    async loadCurrentRosterTemplate({ commit }, { id, mode }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/roster-templates/${id}`, { params: { mode: mode ? mode : null } })
          .then((response) => {
            commit('setRosterTemplateDownloaded', true);
            commit('setCurrentRosterTemplate', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async isRosterTemplateUsed({ commit }, template_id) {
      return new Promise(async (resolve, reject) => {
        commit('setRosterTemplateUsed', null);
        return await $http()
          .get(`/roster-templates/${template_id}/usage`)
          .then(async (response) => {
            commit('setRosterTemplateUsed', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async disableTemplateAction({ commit }, { template_id, form }) {
      commit('setRosterTemplateDisabled', null);
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/roster-templates/${template_id}/status`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            commit('setRosterTemplateDisabled', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            commit('setRosterTemplateDisabled', false);
            return reject(error);
          });
      });
    },

    async loadCurrentMonthRoster({ commit }, { month, year, churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .get(`organisations/${churchId}/rosters/${month}/${year}`, { canBeImpersonated: true })
          .then(async (response) => {
            commit('setCurrentMonthRoster', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            commit('setCurrentMonthRoster', null);
            return reject(error);
          });
      });
    },

    async SEND_CURRENT_MONTH_ROSTER_NOTIFICATIONS() {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/sms/rosters/current-month-roster-notifications', undefined, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async CHECK_DEFAULT_ROSTER_TEMPLATE_EXISTENCE({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/organisations/${churchId}/roster-templates/default-templates/existence`, {
            canBeImpersonated: true,
          })
          .then(async (response) => {
            commit('setDefaultRosterTemplateExistence', response.data.data);
            return resolve(response);
          })
          .catch((error) => {
            commit('setDefaultRosterTemplateExistence', null);
            return reject(error);
          });
      });
    },

    async PRINT_ROSTER(ctx, { month, year, churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/prints/rosters/${month}/${year}`, { responseType: 'blob' })
        .then(async (response) => {
          return await downloadFileFromResponse(response, 'roster');
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async DELETE_ROSTER_TEMPLATE_ACTION(ctx, { id }) {
      return $http()
        .delete(`roster-templates/${id}`, {
          notifiable: true,
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
  },
};
